import { environmentProvider } from '@shared/environment-provider';
import {
  accountsEnvironment,
  auditLogEnvironment,
  ciphEnvironment,
  CloudProvider,
  copilotMessagePublisherEnvironment,
  enterpriseLogsEnvironment,
  fleetEnvironment,
  fleetStatsEnvironment,
  licenseTrackerEnvironment,
  mapManagementServiceEnvironment,
  miEnvironment,
  pcMilerWebServicesEnvironment,
  placesEnvironment,
  routingProfileServiceEnvironment,
  smsNotificationServiceEnvironment,
} from '@tmx/data-access';

export const configureCloudProviderApiBaseUrls = (
  cloudProvider: CloudProvider
) => {
  const urls = environmentProvider.getCloudProviderBaseUrls(cloudProvider);

  accountsEnvironment.baseUrl = urls.accountsApiBaseUrl;
  fleetEnvironment.baseUrl = urls.fleetApiBaseUrl;
  fleetStatsEnvironment.baseUrl = urls.fleetStatsApiBaseUrl;
  routingProfileServiceEnvironment.baseUrl =
    urls.routingProfileServiceApiBaseUrl;
  copilotMessagePublisherEnvironment.baseUrl =
    urls.copilotMessagePublisherApiBaseUrl;
  enterpriseLogsEnvironment.baseUrl = urls.enterpriseLogsServiceApiBaseUrl;
  ciphEnvironment.baseUrl = urls.cpihApiBaseUrl;
  miEnvironment.baseUrl = urls.mobileInstructionsApiBaseUrl;
  smsNotificationServiceEnvironment.baseUrl =
    urls.smsNotificationServiceApiBaseUrl;
  licenseTrackerEnvironment.baseUrl = urls.licenseTrackerApiBaseUrl;
  auditLogEnvironment.baseUrl = urls.auditLogApiBaseUrl;
  mapManagementServiceEnvironment.baseUrl = urls.mapManagementServiceApiBaseUrl;
  pcMilerWebServicesEnvironment.baseUrl = urls.pcMilerWebServicesApiBaseUrl;
  placesEnvironment.baseUrl = urls.placesApiBaseUrl;
};
